import {
  Component,
  HostListener,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  Inject,
  PLATFORM_ID,
} from '@angular/core';

import { LoadingService } from './services/loading.service';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {

  // isLoading = true;

  title = 'infithra-ssr';
  navHeight = 70;
  lastScrollY = 0;
  delta = 10;
  didScroll = false;

  loading = true;
  showPopup: boolean = false;


  constructor(
    private router: Router,
    private loadingService: LoadingService,
    public translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object, // Inject platformId for SSR detection
    @Inject(DOCUMENT) private doc: Document
  ) {
    // let lang = 'en'
    // if (localStorage.getItem('language') != undefined  ) {
    //   lang = localStorage.getItem('language') || 'en';
    // }
    // translate.use(lang).subscribe(() => {
    //   this.loading = false;
    // });

    this.isRouteShow();
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use(
      browserLang && browserLang.match(/en|ar/) ? browserLang : 'en'
    );

    // this.isBrowser = isPlatformBrowser(this.platformId);

    // If in the browser, hide the static spinner
    // if (this.isBrowser) {
    //   const loader = document.getElementById('global-loader');
    //   if (loader) {
    //     loader.style.display = 'none';
    //   }
    // }

    // Check route visibility logic
    this.isRouteShow();
  }

  routeArray: string[] = ['/login', '/authentication', '/hr-software-uae', '/ai-information'];

  isRouteShow() {
    const urlTree = this.router.parseUrl(this.router.url);
    const primary = urlTree.root.children['primary'];
    const segments = primary ? primary.segments.map((segment) => segment.path) : [];
    const path = '/' + segments.join('/');
    const normalizedPath = path === '/' && segments.length === 0 ? '/' : path.replace(/\/{2,}/g, '/');

    if (!this.routeArray.includes(normalizedPath)) {
      return true;
    }
    return false;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!isPlatformBrowser(this.platformId)) return;

    let target = event.target as HTMLElement | null;
    let clickSource = 'body';

    while (target) {
      if (target.tagName === 'APP-HEADER' || target.tagName === 'APP-HEADER-TOP-BOX') {
        clickSource = 'header';
        break;
      }
      if (target.tagName === 'APP-FOOTER') {
        clickSource = 'footer';
        break;
      }
      target = target.parentElement;
    }

    sessionStorage.setItem('click_source', clickSource);
  }

  scrolled(): void {
    let sy = window.scrollY;
    if (Math.abs(this.lastScrollY - sy) > this.delta) {
      if (sy > this.lastScrollY && sy > this.navHeight) {
        this.didScroll = true;
      } else if (sy < this.lastScrollY) {
        this.didScroll = false;
      }
      this.lastScrollY = sy;
    }
  }
  ngOnInit(): void {
    // Check for encoded URLs on initial load
    if (isPlatformBrowser(this.platformId)) {
      this.checkAndHandleEncodedUrl();

      // Smoothly fade out the static bootstrap shell loader
      const globalLoader = this.doc.getElementById('global-loader');
      if (globalLoader) {
        globalLoader.classList.add('fade-out');
        setTimeout(() => {
          globalLoader.style.display = 'none';
        }, 400);
      }
    }

    this.updateCanonicalTag();

    // Subscribe to router events for showing/hiding page loader during navigation
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loadingService.clear();
        // Do not show page loader when navigating to blog detail page (e.g. /blog/slug)
        const isBlogDetail = /^\/blog\/.+/.test(event.url);
        if (!isBlogDetail) {
          this.loadingService.show();
        }
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loadingService.hide();
      }

      if (event instanceof NavigationEnd) {
        const currentRoute = this.router.url;
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem('currentRoute', currentRoute); // Store only the current route (browser only)
        }

        // Check for encoded URLs after navigation
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('currentRoute', currentRoute); // Store only the current route
          this.checkAndHandleEncodedUrl();

          // Automatically track previous route in sessionStorage
          const activeRoute = sessionStorage.getItem('activeRoute');
          if (activeRoute && activeRoute !== currentRoute) {
            const clickSource = sessionStorage.getItem('click_source') || 'body';

            let displayPath = activeRoute.split('?')[0].split('#')[0];
            if (displayPath.startsWith('/')) {
              displayPath = displayPath.substring(1);
            }
            if (!displayPath) {
              displayPath = 'home';
            }

            if (clickSource === 'header') {
              sessionStorage.setItem('previous_page', 'header - ' + displayPath);
            } else if (clickSource === 'footer') {
              sessionStorage.setItem('previous_page', 'footer - ' + displayPath);
            } else {
              sessionStorage.setItem('previous_page', displayPath);
            }
          }
          sessionStorage.setItem('activeRoute', currentRoute);
          sessionStorage.removeItem('click_source'); // Clear click source for the next navigation
        }

        if (currentRoute === '/404' || currentRoute.includes('not-found') || currentRoute === '/ai-information') {
          this.showPopup = false; // Hide popup on 404 page and AI information page
        } else {
          this.checkCookiePopup();
        }
        this.updateCanonicalTag();
      }
    });
  }
  private checkAndHandleEncodedUrl(): void {
    const pathname = window.location.pathname;
    const href = window.location.href;

    // Check if URL contains %23 (encoded #)
    if (pathname.includes('%23') || (href.includes('%23') && !href.includes('#'))) {
      try {
        // Decode and redirect
        const decodedPath = decodeURIComponent(pathname);
        if (decodedPath.includes('#')) {
          const [basePath, fragment] = decodedPath.split('#');
          const cleanPath = basePath.replace(/^\/+|\/+$/g, '');
          const navPath = cleanPath ? cleanPath.split('/').filter(p => p) : [];

          // Only redirect if we're not already on the correct route
          const currentPath = this.router.url.split('?')[0].replace(/^\/+|\/+$/g, '');
          const targetPath = navPath.join('/');

          if (currentPath !== targetPath) {
            this.router.navigate(navPath.length > 0 ? navPath : ['/'], {
              fragment: fragment,
              replaceUrl: true,
              queryParamsHandling: 'preserve'
            });
          }
        }
      } catch (error) {
        console.error('Error handling encoded URL:', error);
      }
    }
  }

  checkCookiePopup(): void {
    if (typeof localStorage === 'undefined') return; // runs via router events during SSR; no localStorage there
    // Show the consent banner immediately (not after a delay) whenever the
    // visitor hasn't made a choice yet — trackers stay paused until they do.
    const consent = localStorage.getItem('cookie_consent');
    const legacyAccepted = localStorage.getItem('cookieAccepted') === 'true';
    const route = localStorage.getItem('currentRoute');

    const decided = consent === 'granted' || consent === 'denied' || legacyAccepted;
    if (route !== '/404' && !decided) {
      this.showPopup = true;
    }
  }

  // Persist the choice and flip the global gate so trackers in index.html can
  // (or can never) fire this session without needing a reload.
  acceptCookies(): void {
    this.setConsent('granted', true);
  }

  declineCookies(): void {
    this.setConsent('denied', false);
  }

  private setConsent(value: 'granted' | 'denied', allowed: boolean): void {
    try {
      localStorage.setItem('cookie_consent', value);
    } catch { /* storage blocked — choice just isn't remembered */ }
    (window as any).trackingConsent = allowed;
    this.showPopup = false;
  }

  // Dismiss without choosing (the ✕): keep tracking paused and re-ask next visit.
  closePopup(): void {
    this.showPopup = false;
  }

  private updateCanonicalTag(): void {
    try {
      const pathWithoutQueryOrHash = this.router.url.split('?')[0].split('#')[0];
      // Always canonicalize to the production origin so dev/staging renders
      // and any mirrored hostname point crawlers at the real URL.
      const canonicalHref = 'https://infithra.com' + pathWithoutQueryOrHash;
      let linkEl = this.doc.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
      if (linkEl) {
        linkEl.setAttribute('href', canonicalHref);
      } else {
        linkEl = this.doc.createElement('link');
        linkEl.setAttribute('rel', 'canonical');
        linkEl.setAttribute('href', canonicalHref);
        this.doc.head.appendChild(linkEl);
      }
      this.updateHreflangTags(canonicalHref);
    } catch (e) {
      // no-op
    }
  }

  // Self-referencing hreflang. The site serves a single language version per
  // URL (Arabic is a runtime toggle at the same URL, not a distinct path), so
  // only `en` + `x-default` apply and both point at the current page.
  private updateHreflangTags(href: string): void {
    for (const lang of ['en', 'x-default']) {
      let el = this.doc.querySelector(`link[rel='alternate'][hreflang='${lang}']`) as HTMLLinkElement | null;
      if (el) {
        el.setAttribute('href', href);
      } else {
        el = this.doc.createElement('link');
        el.setAttribute('rel', 'alternate');
        el.setAttribute('hreflang', lang);
        el.setAttribute('href', href);
        this.doc.head.appendChild(el);
      }
    }
    // Remove any stale `ar` hreflang inherited from the static shell — there is
    // no distinct Arabic URL to point it at.
    const ar = this.doc.querySelector("link[rel='alternate'][hreflang='ar']");
    if (ar) ar.remove();
  }


}